// File: TrustAnnualCompliance.jsx
import React from "react";

export default function TrustAnnualCompliance() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Trust Annual Compliance
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks ensures trusts meet legal and tax compliance obligations.
          </p>
          <p className="text-gray-700">
            Complete annual compliance including ITR-5/ITR-7 filings, Form 10B audits, 12A/80G renewals, wealth tax declarations, trustee resolutions, and statutory register maintenance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Trust compliance - legal documents/safe/estate planning) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/5066684/pexels-photo-5066684.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Trust annual compliance - legal documents and estate planning"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless trust compliance filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Trust deed and amendments</li>
                <li>Audited accounts and financial statements</li>
                <li>Form 10B audit reports</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Trust-specific regulatory expertise with proven success in Income Tax, Registration Act, and statutory compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Income Tax Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete ITR-5/ITR-7 filings, Form 10B audit coordination, 12A/80G certificate renewals, wealth tax computations, trustee KYC compliance, and Income Tax assessment handling.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Statutory Register Management
                </h3>
                <p className="text-gray-700 text-sm">
                  Trustee meeting minutes, resolution documentation, beneficiary register maintenance, asset inventory tracking, annual compliance calendars, and statutory record preservation.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Comprehensive Trust Advisory
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service compliance from trust deed amendments through annual filings, auditor coordination, ROC compliance, tax exemption applications, legal opinion support, and ongoing regulatory advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
